import Rules from "@/components/Rules";
import Image from "next/image";

export interface ICategory {
  value: number;
  title: string;
  icon: string;
  faqData: {
    id: number;
    question: string;
    answer: string;
    moreInfo?: JSX.Element | string;
  }[];
}
export interface IPublicItem_FAQs {
  value: number;
  lable: string;
  category: ICategory[];
}

export const PublicItems_FAQs: IPublicItem_FAQs[] = [
  {
    value: 0,
    lable: "مهمان",
    category: [
      {
        value: 1,
        title: "اعتبار و پرداخت",
        icon: "/assets/faq/faq-guest-1.svg",
        faqData: [
          {
            id: 1,
            question: "روش پرداخت رزرو چگونه است؟",
            answer:
              "چنانچه قصد استفاده از خدمات لیدوما را دارید به دو صورت آنلاین و کارت ب کارت می‌توانید مبلغ رزرو خود را پرداخت کنید.",
            moreInfo: (
              <div className="text-12 leading">
                <p>
                  چنانچه قصد استفاده از خدمات لیدوما را دارید به دو صورت می‌توانید مبلغ رزرو خود را
                  پرداخت کنید:
                </p>
                <p>
                  1- <span className="text-blue-700">آنلاین:</span> در این روش کل مبلغ رزرو را پس از
                  ثبت و تایید رزرو، به صورت آنلاین پرداخت می‌کنید.
                </p>
                <p>
                  2- <span className="text-blue-700">آفلاین:</span> در این روش کل مبلغ رزرو را پس از
                  ثبت و تایید رزرو، به صورت کارت به کارت پرداخت می کنید.
                </p>
              </div>
            ),
          },
          {
            id: 2,
            question: "چگونه می‌توانم از کد تخفیف خود استفاده کنم؟",
            answer:
              "در صورت داشتن کد تخفیف، پس از تایید میزبان برای پرداخت رزرو و قبل از انتخاب روش پرداخت، گزینه «کد تخفیف» را انتخاب کنید",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20">
                  در صورت داشتن کد تخفیف، پس از تایید میزبان برای پرداخت رزرو و قبل از پرداخت، گزینه
                  «کد تخفیف» را انتخاب کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat1-q2-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p>در مرحله بعد کد تخفیف را وارد کرده و گزینه «بررسی کد » را انتخاب کنید.</p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat1-q2-2.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p>
                  پس از بررسی کد تخفیف توسط سیستم، در صورت صحیح بودن کد، پیام تاییدی مطابق تصویر زیر
                  از سیستم دریافت خواهید کرد.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat1-q2-3.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
        ],
      },
      {
        value: 2,
        title: "پیگیری رزرو",
        icon: "/assets/faq/faq-guest-2.svg",
        faqData: [
          {
            id: 1,
            question:
              "آیا امکان تغییر در اطلاعات رزرو (تعداد نفرات، تاریخ ورود و خروج) بعد از تأیید میزبان وجود دارد؟",
            answer:
              "مهمان می‌تواند از طریق تماس با پشتیبانی لیدوما درخواست خود را مطرح کرده تا در صورت موافقت میزبان، تغییرات اعمال شود.",
            moreInfo: "",
          },
          {
            id: 2,
            question: "آیا امکان تغییر اقامتگاه انتخاب شده وجود دارد؟",
            answer:
              "پیش از پرداخت و قطعی شدن رزرو، امکان ویرایش وجود دارد اما بعد از آن، هرگونه تغییر در رزرو نیازمند هماهنگی با میزبان است.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 3,
        title: "جستجو و ثبت رزرو",
        icon: "/assets/faq/faq-guest-3.svg",
        faqData: [
          {
            id: 1,
            question: "چگونه می‌توانم از فیلترهای جستجو استفاده کنم؟",
            answer:
              "ابتدا شهر مورد نظر خود را جستجو کنید. با انتخاب گزینه «فیلترها» مطابق تصویر زیر می‌توانید بر اساس بازه قیمت، نوع اقامتگاه، قوانین لغو رزرو و ... جستجوی خود را فیلتر کنید.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  ابتدا شهر مورد نظر خود را جستجو کنید. با انتخاب گزینه «فیلتر» مطابق تصویر زیر
                  می‌توانید بر اساس بازه قیمت، نوع اقامتگاه، قوانین لغو رزرو و … جستجوی خود را فیلتر
                  کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat3-q1-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
          {
            id: 2,
            question: "چگونه می‌توانم بر اساس نقشه، اقامتگاه مورد نظر خود را جستجو کنم؟",
            answer:
              "پس از جستجوی مقصد خود گزینه «نقشه» را انتخاب کنید. این گزینه به صورت شناور بوده و برای شما قابل مشاهده است.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  پس از جستجوی مقصد خود گزینه «نقشه» را انتخاب کنید. این گزینه به صورت شناور بوده و
                  بعد از اسکرول برای شما قابل مشاهده است.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat3-q2-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  در مرحله بعد، با استفاده از نقشه می‌توانید اقامتگاه‌های نزدیک به مکان مورد نظرتان
                  را مشاهده و انتخاب کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat3-q2-2.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
          {
            id: 3,
            question: "چگونه می‌توانم اقامتگاه مورد نظرم را رزرو کنم؟",
            answer:
              "ابتدا اقامتگاه مورد نظرتان را بر اساس نام شهر، کد اقامتگاه، نام اقامتگاه، امکانات اقامتگاه و تاریخ سفر خود جستجو کنید.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  ابتدا اقامتگاه مورد نظرتان را بر اساس نام شهر، کد اقامتگاه و یا نام اقامتگاه و
                  تاریخ سفر خود جستجو کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat3-q3-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  پس از بررسی اقامتگاه‌های موجود با کلیک بر روی اقامتگاه مورد نظر خود و مشاهده
                  جزئیات اطلاعات این اقامتگاه، گزینه «درخواست رزرو» را انتخاب کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat3-q3-2.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  در مرحله بعد جزئیات رزرو برای شما قابل مشاهده خواهد بود، در صورت صحت اطلاعات،
                  گزینه «درخواست رزرو» را مجددا انتخاب کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat3-q3-3.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  پس از انتخاب گزینه «درخواست رزرو»، رزرو شما ثبت شده و درخواست رزرو جهت تایید و یا
                  عدم تایید برای میزبان ارسال خواهد شد.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat3-q3-4.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  در برخی از درخواست‌ها با توجه به تایید آنی میزبان، نیازی به انتظار برای تایید
                  نبوده و بلافاصله بعد از ثبت رزرو، گزینه «پرداخت صورتحساب» برای شما قابل مشاهده و
                  انتخاب است. شما می‌توانید با انتخاب این گزینه رزرو خود را پرداخت و نهایی کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat3-q3-5.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  پس از اطمینان از درخواست رزرو، با پرداخت صورتحساب، درخواست شما قطعی شده، فاکتور
                  رزرو برای شما صادر شده و میزبان لیدوما آماده پذیرایی از شما می باشد.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat3-q3-6.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
          {
            id: 4,
            question: "آیا می‌توانم اقامتگاه را برای شخص دیگری رزرو کنم؟",
            answer:
              "بله، شما می‌توانید با حساب کاربری خود برای مهمانان دیگر درخواست رزرو ثبت کنید. تنها لازم است تا اطلاعات شخصی مهمان به درستی و با دقت درج شود.",
            moreInfo: "",
          },
          {
            id: 5,
            question: "چگونه می‌توانم اطلاعات اقامتگاه را مشاهده کنم؟",
            answer:
              "ابتدا مقصد و تاریخ خود را انتخاب و جستجو کنید. بعد از مشاهده نتیجه جستجو، برای مشاهده اطلاعات اقامتگاه (قوانین لغو رزرو، ظرفیت پایه، موقعیت مکانی و ...) کافیست بر روی اقامتگاه مورد نظر خود کلیک کنید.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 4,
        title: "حساب کاربری",
        icon: "/assets/faq/faq-guest-4.svg",
        faqData: [
          {
            id: 1,
            question: "چطور می‌توانم ثبت‌نام کنم؟",
            answer:
              "برای رزرو هتل یا اقامتگاه نیاز به ثبت‌نام در سایت است. برای اینکار ابتدا شماره موبایل خود را مطابق تصویر زیر وارد کنید.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  برای رزرو اقامتگاه یا هتل نیاز به ثبت‌نام در سایت است. برای اینکار ابتدا شماره
                  موبایل خود را مطابق تصویر زیر وارد کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q1-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  با انتخاب دکمه «تأیید و ادامه»، کد تایید به شماره موبایل شما ارسال خواهد شد. پس از
                  دریافت کد تایید، برای ادامه روند ثبت‌نام این کد را در باکس مربوطه مطابق تصویر زیر
                  وارد کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q1-2.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  پس از وارد کردن کد تایید یکبار مصرف و کلیک بر روی گزینه «ورود»، شما باید نام، نام
                  خانوادگی و یک رمز عبور مطابق با شرایط مشخص شده برای خود تعیین و گزینه «ثبت نام» را
                  انتخاب کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q1-3.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
          {
            id: 2,
            question: "چطور می توانم وارد حساب کاربری خود شوم؟",
            answer:
              "برای وارد شدن به حساب کاربری، شماره موبایل خود را در باکس مربوطه مطابق تصویر زیر وارد کنید.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  برای وارد شدن به حساب کاربری، شماره موبایل خود را در باکس مربوطه مطابق تصویر زیر
                  وارد کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q2-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  با انتخاب دکمه «تأیید و ادامه»، در این مرحله می‌توانید با وارد کردن رمز عبور
                  تعیین‌شده توسط شما، وارد حساب کاربریتان شوید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q2-2.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  همچنین می توانید با انتخاب گزینه ورود با کد یکبار مصرف، با ارسال کد یکبار مصرف به
                  شماره موبایل وارد شده، وارد حساب کاربری خود شوید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q2-3.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
          {
            id: 3,
            question: "چطور می توانم رمز عبور خود را تغییر دهم؟",
            answer: "برای تغییر رمز عبور، با انتخاب گزینه «حساب کاربری» وارد حساب کاربری خود شوید.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  برای تغییر رمز عبور، با انتخاب گزینه «ویرایش حساب کاربری» وارد حساب کاربری خود
                  شوید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q3-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  پس از انتخاب گزینه «تغییر رمز عبور»، مطابق تصویر زیر،رمز عبور جدید را انتخاب کنید
                  و در پایان برای اعمال این تغییرات گزینه «ذخیره» را انتخاب کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q3-2.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
          {
            id: 4,
            question: "چگونه می‌توانم اطلاعات حساب کاربری خود را ویرایش کنم؟",
            answer:
              "ابتدا با انتخاب گزینه «حساب کاربری» وارد حساب کاربری خود شوید و پس از ورود، گزینه «اطلاعات حساب کاربری» را انتخاب کنید.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  ابتدا با انتخاب گزینه «ویرایش حساب کاربری» وارد حساب کاربری خود شوید و پس از ورود،
                  می توانید نسبت به ویرایش اطلاعات حساب کاربری خود اقدام نمایید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q4-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
          {
            id: 5,
            question: "چگونه می‌توانم اعتبارم را افزایش دهم؟",
            answer:
              "برای افزایش اعتبار حساب کاربری با کارت‌های عضو شتاب، ابتدا وارد حساب کاربری خود شوید، سپس گزینه «کیف پول» را مطابق تصویر زیر انتخاب کنید.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  برای افزایش اعتبار حساب کاربری با کارت‌های عضو شتاب، از قسمت حساب کاربری وارد قسمت
                  کیف پول شوید، سپس گزینه «افزایش موجودی کیف پول» را مطابق تصویر زیر انتخاب کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q5-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  در مرحله بعد مقدار مبلغی که تمایل دارید در کیف پول خود شارژ کنید را مشخص و گزینه
                  «افزایش اعتبار» را انتخاب کنید. پس از انتخاب این گزینه وارد درگاه پرداخت شده و
                  می‌توانید مبلغ مورد نظرتان برای افزایش اعتبار را پرداخت کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q5-2.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
          {
            id: 6,
            question: "چطور می‌توانم تراکنش های مالی خود را ببینم؟",
            answer:
              "ابتدا با انتخاب گزینه «حساب کاربری» وارد حساب کاربری خود شوید. پس از ورود، گزینه «کیف پول» را انتخاب کنید.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  برای مشاهده تراکنش های مالی خود از قسمت حساب کاربری وارد قسمت کیف پول شوید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q6-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  در این قسمت می‌توانید تمامی تراکنش‌های مالی خود را در صفحه‌ای مطابق تصویر زیر
                  مشاهده کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat4-q6-2.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
        ],
      },
      {
        value: 5,
        title: "لغو رزرو",
        icon: "/assets/faq/faq-guest-5.svg",
        faqData: [
          {
            id: 1,
            question: "چگونه می‌توانم قبل از رزرو، از شرایط لغو رزرو آن اقامتگاه آگاه شوم؟",
            answer:
              "شرایط لغو رزرو هر اقامتگاه به طور اختصاصی در اطلاعات اقامتگاه ثبت شده است. برای مشاهده قوانین لغو رزرو بر روی اقامتگاه مورد نظر کلیک و قسمت قوانین لغور رزرو را مطالعه کنید.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  شرایط لغو رزرو هر اقامتگاه به طور اختصاصی در بخش قوانین لغو رزرو اقامتگاه ثبت شده
                  است. برای مشاهده قوانین لغو رزرو بر روی اقامتگاه مورد نظر کلیک و قسمت قوانین لغو
                  رزرو را مطالعه کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat5-q1-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
          {
            id: 2,
            question: "در صورت لغو رزرو از جانب میزبان سرنوشت رزرو به چه صورت خواهد بود؟",
            answer:
              "در اولین اقدام، اقامتگاه جایگزین به مهمان پیشنهاد می‌شود و در صورت عدم رضایت مهمان، مبلغ رزرو به صورت کامل به ایشان عودت داده می‌شود.",
            moreInfo: "",
          },
          {
            id: 3,
            question: "در صورت عدم رضایت از اقامتگاه چه اقدامی انجام دهیم؟",
            answer:
              "با تماس با تیم پشتیبانی لیدوما و مطرح کردن مشکل خود، واحد شکایت لیدوما سریعاً موضوع را بررسی خواهند کرد.",
            moreInfo: "",
          },
          {
            id: 4,
            question: "فرآیند لغو رزرو به چه صورت است؟",
            answer:
              "در صورت تمایل به استرداد رزرو، با وارد شدن به حساب کاربری خود و مراجعه به قسمت سفرهای من، اقامتگاه مورد نظر خود را انتخاب و وارد فرآیند لغو رزرو شوید. با انتخاب گزینه «لغو رزرو و بازگشت وجه»، علت لغو رزرو خود را مشخص و گزینه «ادامه» را انتخاب کنید.",
            moreInfo: (
              <div className="flex flex-col items-center">
                <p className="text-12 leading-20 mb-4">
                  در صورت تمایل به استرداد رزرو، با وارد شدن به حساب کاربری خود و مراجعه به قسمت
                  سفرهای من، اقامتگاه مورد نظر خود را انتخاب و وارد فرآیند لغو رزرو شوید. با انتخاب
                  گزینه «لغو رزرو و بازگشت وجه»، علت لغو رزرو خود را مشخص و گزینه «ادامه» را انتخاب
                  کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat5-q4-1.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  با انتخاب دکمه «تأیید و ادامه»، کد تایید به شماره موبایل شما ارسال خواهد شد. پس از
                  دریافت کد تایید، برای ادامه روند ثبت‌نام این کد را در باکس مربوطه مطابق تصویر زیر
                  وارد کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat5-q4-2.svg"
                  alt=""
                  width={320}
                  height={429}
                />
                <p className="text-12 leading-20 mb-4">
                  پس از وارد کردن کد تایید یکبار مصرف و کلیک بر روی گزینه «ورود»، شما باید نام، نام
                  خانوادگی و یک رمز عبور مطابق با شرایط مشخص شده برای خود تعیین و گزینه «ثبت نام» را
                  انتخاب کنید.
                </p>
                <Image
                  src="/assets/faq/more-info/guest/guest-cat5-q4-3.svg"
                  alt=""
                  width={320}
                  height={429}
                />
              </div>
            ),
          },
          {
            id: 5,
            question: "در صورت لغو رزرو چه درصدی از مبلغ رزرو به عنوان جریمه کسر خواهد شد؟",
            answer:
              "براساس قوانین لغو رزرو مرتبط با اقامتگاه، جریمه لغو رزرو محاسبه خواهد شد. لطفا پیش از انتخاب اقامتگاه و رزرو، قوانین لغو آن اقامتگاه را مطالعه کنید.",
            moreInfo: "",
          },
          {
            id: 6,
            question: "پس از لغو رزرو، فرآیند دریافت وجه به چه صورت است؟",
            answer:
              "چنانچه اطلاعات حساب بانکی شما در پروفایل تکمیل شده باشد، مبلغ رزرو حداکثر تا 24 ساعت کاری به حساب شما واریز خواهد شد.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 6,
        title: "مدارک محرمیت",
        icon: "/assets/faq/faq-guest-6.svg",
        faqData: [
          {
            id: 1,
            question: "برای تحویل گرفتن اقامتگاه، به چه مدارکی نیاز است؟",
            answer:
              "احراز هویت با کارت ملی و یا شناسنامه و احراز شرایط محرمیت، از طریق وجود نام زوج در شناسنامه همسر امکان‌پذیر است. در برخی هتل‌ها صیغه‌نامه با مهر برجسته نیز پذیرفته می‌شود. این نوع از پذیرش عمومیت ندارد؛ در صورت عدم احراز شرایط محرمیت، اقامتگاه‌ها از ورود مسافرین به اتاق ها ممانعت کرده و مطابق قوانین لغو رزرو عمل می‌کنند.",
            moreInfo: "",
          },
          {
            id: 2,
            question:
              "در صورت همراه نداشتن مدارک محرمیت، برای زوجین امکان رزرو اقامتگاه وجود دارد؟",
            answer:
              "بله، برای اقامتگاه در صورت هماهنگی با میزبان این امکان وجود دارد اما برای مجتمع اقامتی، اقامتگاه بومگردی و سنتی، هتل، هاستل و مهمانسرا بدون مدارک محرمیت، پذیرش و رزرو مهمان مقدور نیست.",
            moreInfo: "",
          },
          {
            id: 3,
            question: "امکان پذیرش گروه‌های مجردی به چه معناست؟",
            answer: "منظور از گروههای مجردی، گروه‌های صرفا آقا و یا صرفا خانم است.",
            moreInfo: "",
          },
        ],
      },
    ],
  },
  {
    value: 1,
    lable: "میزبان",
    category: [
      {
        value: 1,
        title: "اعلان ها",
        icon: "/assets/faq/faq-host-1.svg",
        faqData: [
          {
            id: 1,
            question: "چگونه می‌توانم رزروهای ارسالی برای اقامتگاه خود را ببینم؟",
            answer:
              "برای مشاهده تمام پیام‌های ارسالی از سایت لیدوما درباره وضعیت رزروهای اقامتگاه‌‌ها و امتیاز دهی مهمانان، می‌توانید به قسمت اعلان‌ها مراجعه کنید.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 2,
        title: "ایجاد و ویرایش اقامتگاه",
        icon: "/assets/faq/faq-host-2.svg",
        faqData: [
          {
            id: 1,
            question: "اقامتگاه اشتراکی چیست و چه تفاوتی با اقامتگاه دربستی دارد؟",
            answer:
              "منظور از اقامتگاه دربستی اقامتگاهی است که به‌طور کامل و دربست در اختیار مهمان قرار می‌گیرد. به عنوان مثال‌هایی از این گروه می‌توان به ویلا، خانه، آپارتمان، کلبه و … اشاره کرد.",
            moreInfo: "",
          },
          {
            id: 2,
            question: "نکاتی که در بخش مشخصات اقامتگاه باید به آن‌ها توجه کرد، شامل چه مواردی است؟",
            answer:
              "منظور از مشخصات اقامتگاه، نام اقامتگاه، توضیحاتی درباره اقامتگاه، مساحت زیر بنا و مساحت کل بنا می‌باشد. در این قسمت شما می‌بایست اطلاعات نام و توضیحات اقامتگاه خود را به زبان فارسی و به گونه‌ای که برای مهمان شما شفاف باشد بیان کنید.",
            moreInfo: "",
          },
          {
            id: 3,
            question: "منظور از ظرفیت پایه، ظرفیت کل و نفر اضافه چه می‌باشد؟",
            answer:
              "منظور از ظرفیت پایه، حداکثر تعداد نفراتی است که برای یک اقامتگاه، استاندارد در نظر گرفته می‌شود. علاوه بر این تعداد میزبان می‌تواند تعداد نفر اضافه قابل مجاز برای یک اقامتگاه را مشخص کند.",
            moreInfo: "",
          },
          {
            id: 4,
            question: "اهمیت امکانات اقامتگاه در جلب توجه و رضایت مهمان چگونه است؟",
            answer:
              "امکانات اقامتگاه شما شامل مواردی مانند تعداد حمام،‌ سرویس بهداشتی ایرانی و فرنگی و سایر امکانات موجود در اقامتگاه که در اختیار مهمان‌ها قرار می‌گیرد می‌باشد. مشاهده و بررسی امکانات اقامتگاه یکی از مهمترین کارهایی است که در زمان رزرو و انتخاب یک اقامتگاه برای مهمانان از اهمیت بالایی برخوردار است.",
            moreInfo: "",
          },
          {
            id: 5,
            question: "توجه به چه نکاتی هنگام افزودن آدرس اقامتگاه ضروری است؟",
            answer:
              "به منظور ثبت و تایید اقامتگاه شما می‌بایست در بخش آدرس اقامتگاه اطلاعات استان، شهر و آدرس دقیق اقامتگاه خود را مشخص کنید. همچنین شما می‌توانید مکان اقامتگاه خود را به صورت دقیق بر روی نقشه جهت ایجاد تجربه‌ای بهتر برای مهمانان انتخاب کنید.",
            moreInfo: "",
          },
          {
            id: 6,
            question: "قوانین اقامتگاه شامل چه مواردی است و هر مورد بیانگر چیست؟",
            answer:
              "در بخش مقررات اقامتگاه، قوانینی که مهمان باید برای بهره‌مندی از آن اقامتگاه رعایت کند آورده شده است.",
            moreInfo: "",
          },
          {
            id: 7,
            question: "منظور از قوانین لغو رزرو چیست و چه نکاتی را شامل می‌شود؟",
            answer:
              "با انتخاب قوانین و مقررات اقامتگاه از میان حالات مختلف تعیین شده، قوانین لغو رزرو اقامتگاه توسط میزبان به ازای هر اقامتگاه مشخص می‌شود. لغو رزرو توسط مهمان از طریق لیدوما می‌تواند بر اساس قوانین لغو رزرو مشمول جریمه شود.",
            moreInfo: "",
          },
          {
            id: 8,
            question: "چگونه می‌توانم اقامتگاه اشتراکی خود را ثبت کنم؟",
            answer:
              "در فرآیند ثبت اقامتگاه، در صورتیکه اقامتگاه شما مانند هاستل یا کاروانسرا اشتراکی و شامل چندین اتاق باشد، پس از افزودن اطلاعات مشخصات اقامتگاه، وارد بخش فضای اقامتگاه خواهید شد. در این بخش شما می‌توانید اطلاعات اتاق‌های خود را به صورت مجزا اضافه کنید.",
            moreInfo: "",
          },
          {
            id: 9,
            question: "چگونه قوانین لغو رزرو خود را ویرایش کنم؟",
            answer:
              "با ورود به اپلیکیشن لیدوما، وارد صفحه لیست اقامتگاه‌ها شده و گزینه ویرایش اقامتگاه را انتخاب کنید.",
            moreInfo: "",
          },
          {
            id: 10,
            question: "چگونه می‌توانم اقامتگاه خود را در سایت لیدوما ثبت کنم؟",
            answer:
              "پس از ثبت‌نام و ایجاد حساب کاربری در لیدوما، از منوی کنار صفحه گزینه میزبان شدن را انتخاب کنید. با انتخاب این گزینه، انواع اقامتگاه (سوئیت، آپارتمان، ویلا و …) برای شما قابل مشاهده است. در این قسمت نوع اقامتگاه خود را انتخاب کنید.",
            moreInfo: "",
          },
          {
            id: 11,
            question: "چگونه می‌توانم اقامتگاه خود را در سایت لیدوما ثبت کنم؟",
            answer:
              "پس از ثبت‌نام و ایجاد حساب کاربری در لیدوما، از منوی کنار صفحه گزینه میزبان شدن را انتخاب کنید. با انتخاب این گزینه، انواع اقامتگاه (سوئیت، آپارتمان، ویلا و …) برای شما قابل مشاهده است. در این قسمت نوع اقامتگاه خود را انتخاب کنید.",
            moreInfo: "",
          },
          {
            id: 12,
            question: "چگونه اقامتگاه خود را ویرایش کنم؟",
            answer:
              "با ورود به اپلیکیشن لیدوما، وارد صفحه لیست اقامتگاه‌ها شده و گزینه ویرایش اقامتگاه را انتخاب کنید.",
            moreInfo: "",
          },
          {
            id: 13,
            question: "چرا بعد از ویرایش، اقامتگاه من روی سایت نمایش داده نمی‌شود؟",
            answer:
              "عدم نمایش اقامتگاه روی سایت پس از ویرایش موقتی بوده و بعد از تایید همکاران مجددا فعال خواهد شد. برای مشاهده وضعیت اقامتگاه خود می‌توانید به قسمت «سوابق تایید و رد اقامتگاه» مراجعه کنید.",
            moreInfo: "",
          },
          {
            id: 14,
            question: "چگونه تصاویر اقامتگاه را تغییر دهم؟",
            answer:
              "با ورود به اپلیکیشن لیدوما، وارد صفحه لیست اقامتگاه‌ها شده و گزینه ویرایش اقامتگاه را انتخاب کنید.",
            moreInfo: "",
          },
          {
            id: 15,
            question: "چطور می‌توانم اقامتگاه خود را غیرفعال کنم؟",
            answer:
              "در صورت عدم تمایل به همکاری، می‌توانید اقامتگاه خود را در لیدوما غیرفعال کنید اما این امر به منزله غیرفعال کردن رزروهای فعال و پیشین شما نیست. در صورتیکه رزرو فعالی داشته باشید (رزروی که تایید شده اما هنوز تاریخ اقامت فرا نرسیده است) موظف به ارائه خدمات به مهمان هستید، در صورتیکه امکان پذیرش مهمان را نداشته باشید لازم است برای ارائه جایگزین به مهمانان در اسرع وقت با پشتیبانی لیدوما تماس بگیرید.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 3,
        title: "حساب کاربری",
        icon: "/assets/faq/faq-guest-4.svg",
        faqData: [
          {
            id: 1,
            question: "برای ثبت‌ اقامتگاه چه مدارکی مورد نیاز است؟",
            answer:
              "برای ثبت اقامتگاه مدارک هویتی میزبان شامل تصویر کارت ملی یا شناسنامه ، و مدارک اقامتگاه، شامل سند یا اجاره‌نامه اقامتگاه، و یا قبض آب و برق، می باشد.",
            moreInfo: "",
          },
          {
            id: 2,
            question: "چه مدتی بعد از ثبت‌نام، اقامتگاه من روی سایت نمایش داده می‌شود؟",
            answer:
              "در صورت تکمیل بودن مدارک پس از بررسی توسط کارشناسان ما نمایش اقامتگاه بین ۲۴ تا  ۷۲ساعت کاری زمان می‌برد.",
            moreInfo: "",
          },
          {
            id: 3,
            question: "چطور می توانم وارد حساب کاربری خود شوم؟",
            answer:
              "برای وارد شدن به حساب کاربری، وارد اپلیکیشن لیدوما شوید، شماره موبایل کاربری خود را در باکس مشخص شده مطابق تصویر زیر وارد کنید.",
            moreInfo: "",
          },
          {
            id: 4,
            question: "چطور می‌توانم رمز عبور خود را تغییر دهم؟",
            answer:
              "برای تغییر رمز عبور ابتدا وارد اپلیکیشن لیدوما شوید، از منوی پایین صفحه گزینه «حساب کاربری» را انتخاب کرده و در صفحه حساب کاربری گزینه «رمز عبور» را انتخاب کنید.",
            moreInfo: "",
          },
          {
            id: 5,
            question: "چطور می‌توانم اطلاعات شخصی حساب کاربری خود را تغییر دهم؟",
            answer:
              "با وارد شدن به اپلیکیشن لیدوما از منوی پایین صفحه گزینه «حساب کاربری» را انتخاب کنید و وارد شوید.",
            moreInfo: "",
          },
          {
            id: 6,
            question: "چطور می توانم اطلاعات بانکی حساب کاربری خود را ویرایش کنم؟",
            answer:
              "با وارد شدن به اپلیکیشن لیدوما از منوی انتهای صفحه گزینه «حساب کاربری» را انتخاب کنید و وارد شوید.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 4,
        title: "درباره میزبانی",
        icon: "/assets/faq/faq-guest-4.svg",
        faqData: [
          {
            id: 1,
            question: "شرایط میزبان شدن در سایت لیدوما چیست؟",
            answer:
              "برای تعریف اقامتگاه در لیدوما لازم است که هر کاربر یک حساب کاربری در سایت ایجاد کند. تنها مالک اقامتگاه و نماینده قانونی ایشان می‌توانند جهت ثبت اقامتگاه در لیدوما حساب کاربری ایجاد کنند.",
            moreInfo: "",
          },
          {
            id: 2,
            question: "آیا امکان ثبت چند اقامتگاه را در سایت لیدوما دارم؟",
            answer:
              "بله، میزبان می‌تواند چندین اقامتگاه را در یک حساب کاربری تعریف کند، اما مجاز نیست که یک اقامتگاه را دوبار تعریف کند، در صورت مشاهده، اقامتگاه و نام کاربری ایشان مسدود می‌شود.",
            moreInfo: "",
          },
          {
            id: 3,
            question: "بعد از دریافت درخواست رزرو باید چه کار کنم؟",
            answer:
              "پس از دریافت پیامک رزرو، با وارد شدن به اپلیکیشن، گزینه رزرو ها را در منوی پایین صفحه انتخاب کنید و مشخصات رزرو دریافتی را چک کنید. با انتخاب دکمه قبول درخواست/ رد درخواست اقدام به تایید/ رد درخواست کاربر کنید.",
            moreInfo: "",
          },
          {
            id: 4,
            question: "آیا می‌توانم درخواست‌های رزرو را رد کنم؟",
            answer:
              "میزبان موظف است تقویم خود را  به‌روز نگه دارد. در صورتیکه به هر دلیل امکان پذیرش مهمان را نداشته باشد باید در آن تاریخ اقامتگاه خود را غیرفعال کند ، اما به هر دلیل اگر این کار از سمت میزبان انجام نشود و رزرو برای میزبان ارسال شود و آمادگی پذیرش مهمان را نداشته باشد می‌تواند درخواست اقامت را بپذیرد و یا رد کند. .در نظر داشته باشید لیدوما به منظور ارتقای کیفیت خدمات و خلق ارزش برای میزبان، از سیاست‌های تشویقی استفاده خواهد که در صورت بالا بودن تعدادِ رد میزبان روی رزروهای درخواست شده میزبان از این مزایا بهره‌ای نخواهد برد.            در صورتیکه میزبان درخواست رزرو را پذیرفت، متعهد به ارائه خدمات براساس آن درخواست است در غیر این‌صورت خسارات وارده به شرکت و عواقب ناشی از آن بر عهده میزبان است و از محل مطالبات ایشان برداشت خواهد شد. همچنین لیدوما می‌تواند حساب کاربری و اقامتگاه میزبان را مسدود کند.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 5,
        title: "عملکرد میزبان",
        icon: "/assets/faq/faq-host-3.svg",
        faqData: [
          {
            id: 1,
            question: "نرخ قبول درخواست چیست و چه اهمیتی دارد؟",
            answer:
              "نرخ قبول درخواست نشان‌دهنده این هست که چند درصد از درخواست‌های رزروی که برای اقامتگاه شما ارسال شده، توسط شما تأیید شده است.",
            moreInfo: "",
          },
          {
            id: 2,
            question: "نرخ بازدید به رزرو چیست؟",
            answer:
              "نرخ قبول درخواست نشان‌دهنده این است که چند درصد از مهمان‌ها، پس از بازدید از صفحه اقامتگاه شما آن را رزرو کرده‌اند. برای مثال اگر 100 مهمان صفحه اقامتگاه شما را در سایت یا اپلیکیشن لیدوما باز کرده باشند و 20 رزرو برای شما ثبت شده باشد، نرخ بازدید به رزرو شما 20% می‌شود.",
            moreInfo: "",
          },
          {
            id: 3,
            question: "میانگین امتیاز از مهمان‌ها چگونه محاسبه میشود و چه اهمیتی دارد؟",
            answer:
              "بعد از پایان هر رزرو از مسافر خواسته می‌شود تا به کیفیت اقامت خود و همچنین کیفیت اقامتگاه امتیاز بدهد و بازخوردش را ثبت کند. میانگین کل امتیازهای کسب‌شده و همچنین بازخورد مهمان در سایت برای عموم نمایش داده می‌شود.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 6,
        title: "قوانین ثبت اقامتگاه",
        icon: "/assets/faq/faq-host-4.svg",
        faqData: [
          {
            id: 1,
            question: "قوانین ثبت اقامتگاه",
            answer:
              "لیدوما تعهد می‌کند نسبت به دریافت مبلغ رزرو اقامتگاه از مسافر به صورت الکترونیک اقدام کرده و پس از کسر کمیسیون به عنوان حق‌الزحمه از مبلغ کل رزرو، در تاریخ خروج مسافر از اقامتگاه به حساب اعلامی از سوی میزبان در حساب کاربری ایشان واریز ‌شود.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 7,
        title: "مدیریت پرداختی ها",
        icon: "/assets/faq/faq-guest-1.svg",
        faqData: [
          {
            id: 1,
            question: "چگونه می‌توانم تراکنش های مالی خود را مشاهده کنم؟",
            answer:
              "برای مشاهده تراکنش‌های مالی کافیست وارد اپلیکیشن شوید، در حساب کاربری خود از منوی کیف پول تراکنش ها را انتخاب کنید.",
            moreInfo: "",
          },
          {
            id: 2,
            question: "در صورت لغو رزرو توسط مسافر، مبلغ رزرو به چه صورت محاسبه خواهد شد؟",
            answer:
              "در صورت لغو رزرو توسط مسافر، مبلغ جریمه بر اساس قانون لغو رزرو انتخاب شده در فرآیند ثبت اقامتگاه که میزبان برای مجموعه خود انتخاب کرده است محاسبه خواهد شد.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 8,
        title: "مدیریت رزورها",
        icon: "/assets/faq/faq-guest-2.svg",
        faqData: [
          {
            id: 1,
            question: "بهتر است قیمت‌گذاری چه زمانی انجام شود؟",
            answer:
              "میزبانان عزیز لازم است تقویم اقامتگاه خود را حداقل تا پایان ماه بعد سال جاری قیمت‌گذاری کنند. این اقدام موجب افزایش نرخ رزرو، کاهش نرخ عدم موجودی و بیشتر دیده‌ شدن اقامتگاه در سایت لیدوما خواهد شد.",
            moreInfo: "",
          },
          {
            id: 2,
            question: "امتیاز اقامتگاه‌ها چگونه و بر چه اساسی ثبت می‌شوند؟",
            answer:
              "مهمانان لیدوما، پس از پایان اقامت و از طریق مشارکت در نظرسنجی، میزان رضایت خود را از پاکیزگی و نظافت، تطابق اطلاعات سایت و اقامتگاه، موقعیت مکانی، کیفیت میزبانی و قیمت اقامتگاه ثبت می‌کنند.این امتیاز متناسب با میزان رضایت مهمانان، از 1 تا 5 متغیر خواهد بود که امتیاز مناسب یک میزبان با عملکرد مناسب از 4 تا 4.5  تعریف می‌شود.از این رو، هرچه میزبانان در جلب رضایتمندی مهمانان موفق‌تر باشند، امتیاز اقامتگاه ایشان بالاتر خواهد بود. مهمان‌نوازی حرفه‌ای و برخورد دوستانه با مهمان‌، امتیاز اقامتگاه شما را بالا می‌برد، پس برای این موضوع اهمیت زیادی قائل شوید.",
            moreInfo: "",
          },
          {
            id: 3,
            question: "چگونه ورود مهمان‌ها را هماهنگ کنیم؟",
            answer:
              "اگر با مهمانی به توافق رسیدید تا ورودش به اقامتگاه زودتر از ساعت 2 ظهر انجام شود، لطفا این موضوع را یک روز قبل، به تیم پشتیبانی لیدوما اطلاع دهید.",
            moreInfo: "",
          },
        ],
      },
      {
        value: 9,
        title: "مدیریت قیمت گذاری و موجودی",
        icon: "/assets/faq/faq-guest-1.svg",
        faqData: [
          {
            id: 1,
            question: "فرآیند قیمت‌گذاری بر روی تقویم به چه صورت می‌باشد؟",
            answer:
              "علاوه بر قیمت‌گذاری جمعی بر روی هر اقامتگاه، شما می‌توانید به ازای روز‌ها و بازه‌های مختلف و بر اساس تقویم، فرآیند قیمت‌گذاری خود را سفارشی کنید.",
            moreInfo: "",
          },
          {
            id: 2,
            question: "تخفیف لحظه آخری اتوماتیک میزبانان چیست؟",
            answer:
              "با تخفیف لحظه آخری اتوماتیک میتوانید نرخ پُر شدن اقامتگاهتان را افزایش دهید و درآمد بیشتری کسب کنید.در این ویژگی جدید، تخفیف لحظه آخری دلخواهتان را وارد میکنید و در صورت فروش نرفتن اقامتگاهتان این تخفیف بصورت اتوماتیک هر روز روی اقامتگاه اعمال میشود و شانس فروش اقامتگاه افزایش میدهد.",
            moreInfo: "",
          },
          {
            id: 3,
            question: "شیوه قیمت‌گذاری اقامتگاه چگونه است؟",
            answer:
              "با وارد شدن به اپلیکیشن لیدوما از منوی پایین صفحه گزینه «اقامتگاه‌ها» را انتخاب کنید و در صورتیکه اقامتگاه شما یک واحد مجزا است، برای قیمت‌گذاری، گزینه «تقویم و قیمت‌گذاری» را انتخاب کنید.",
            moreInfo: "",
          },
          {
            id: 4,
            question: "امکان ثبت نام یا قیمت‌گذاری توسط خود لیدوما وجود دارد؟",
            answer:
              "بله، شما میتوانید از طریق تماس با پشتیبانی لیدوما، تمامی مراحل ثبت نام و تغییر نرخ اقامتگاه را به صورت آفلاین انجام دهید .کارشناسان لیدوما به صورت 24 ساعته اماده دریافت تماس های شما میزبانان هستند",
            moreInfo: "",
          },
          {
            id: 5,
            question: "چگونه می‌توانم برای اقامتگاه خود تخفیف بلند مدت در نظر بگیرم؟",
            answer: "با ورود به اپلیکیشن لیدوما لیست اقامتگاه‌ها را مشاهده خواهید کرد.",
            moreInfo: "",
          },
        ],
      },
    ],
  },
  {
    value: 2,
    lable: "سوالات عمومی",
    category: [
      {
        value: 1,
        title: "حریم شخصی کاربران",
        icon: "/assets/faq/faq-host-1.svg",
        faqData: [
          {
            id: 1,
            question: "حریم شخصی کاربران",
            answer:
              "لیدوما با توجه به احترامی که برای حریم شخصی کاربران قائل است، برای رزرو اقامتگاه و یا ثبت نظر و استفاده از برخی امکانات، اطلاعاتی را از کاربران درخواست می‌کند تا بتواند خدماتی امن و مطمئن را به کاربران ارائه دهد. با توجه به اینکه محصول لیدوما قانونی و مبتنی بر قوانین تجارت الکترونیک است، برای رسیدگی سریع‌تر به درخواست کاربران، اطلاعاتی مانند شماره تلفن از کاربران درخواست می گردد.",
            moreInfo: (
              <div>
                <p className="text-12 leading-20 text-justify mb-4">
                  لیدوما با توجه به احترامی که برای حریم شخصی کاربران قائل است، برای رزرو اقامتگاه و
                  یا ثبت نظر و استفاده از برخی امکانات، اطلاعاتی را از کاربران درخواست می‌کند تا
                  بتواند خدماتی امن و مطمئن را به کاربران ارائه دهد. با توجه به اینکه محصول لیدوما
                  قانونی و مبتنی بر قوانین تجارت الکترونیک است، برای رسیدگی سریع‌تر به درخواست
                  کاربران، اطلاعاتی مانند شماره تلفن از کاربران درخواست می گردد. <br />
                  لیدوما، برای فرآیند ثبت اقامتگاه، مدارکی مانند کارت ملی را از میزبانان درخواست
                  می‌کند تا اطلاعات هویتی آن‌ها را بر اساس قوانین وبسایت، بازبینی کند. لیدوما مدارک
                  شخصی کاربران را محرمانه می‌داند ولی جایز است تا از اطلاعات و مدارک ثبت شده جهت
                  پیگیری قانونی استفاده کند.
                  <br />
                  همچنین لیدوما ممکن است برای ارتباط با مشتریان، بهینه‌سازی محتوای وبسایت و تحقیقات
                  بازاریابی از برخی اطلاعات استفاده کند و برای اطلاع‌رسانی رویدادها و اخبار، خدمات
                  یا پروموشن‌ها، برای اعضای وبسایت ایمیل یا پیامک ارسال نماید. در صورتی که کاربران
                  تمایل به دریافت اینگونه ایمیل‌ها و پیامک‌ها نداشته باشند، می‌توانند نسب به لغو
                  دریافت این خبرنامه‌ها اقدام کنند.
                  <br />
                  لیدوما نقد و نظرهای ارسالی کاربران را بر اساس قوانین وبسایت، بازبینی می‌کند و در
                  صورت نیاز بر روی این نظرات ویرایش انجام می‌دهد. همچنین اگر نظر یا پیام ارسال شده
                  توسط کاربر، مشمول مصادیق محتوای مجرمانه باشد، لیدوما می‌تواند از اطلاعات ثبت شده
                  برای پیگیری قانونی استفاده کند.
                  <br />
                  حفظ و نگهداری رمز عبور بر عهده کاربران است، لذا می‌بایست برای جلوگیری از هرگونه
                  سوء استفاده احتمالی، در حفظ و نگهداری از رمز کاربری خود کوشا باشند. لیدوما هویت
                  شخصی کاربران را محرمانه می‌داند و اطلاعات شخصی آنان را به هیچ شخص یا سازمان دیگری
                  منتقل نمی‌کند، مگر اینکه با حکم قانونی مجبور به در اختیار گذاشتن اطلاعات شخصی
                  کاربران به مراجع دارای صلاحیت گردد.
                  <br />
                  لیدوما همانند سایر وبسایت‌ها از جمع آوری IP و کوکی‌ها استفاده می‌کند، اما پروتکل،
                  سرور و لایه‌های امنیتی لیدوما و روش‌های مناسب مدیریت داده‌ها اطلاعات کاربران را
                  محافظت و از دسترسی‌های غیر قانونی جلوگیری می‌کند.
                  <br />
                  در صورت وجود هرگونه سوال، لطفا با اطلاعات زیر در ارتباط باشید:
                  <br />
                  تلفن تماس: 91070021 – ۰۲۱
                  <br />
                  دفتر: فارس - شیراز - پارک علم وفناوری فارس
                  <br />
                </p>
              </div>
            ),
          },
        ],
      },
      {
        value: 2,
        title: "قوانین و مقررات",
        icon: "/assets/faq/faq-guest-1.svg",
        faqData: [
          {
            id: 1,
            question: "قوانین و مقررات",
            answer:
              "کاربر گرامی، تمام تلاش ما در تدوین این مستند، استفاده بهینه شما از خدمات لیدوما است. به منظور آشنایی هرچه بیشتر حق و حقوق قانونی خود، لطفا موارد زیر را به‌دقت مطالعه کنید.",
            moreInfo: (
              <div>
                <Rules showHeader={false} showSearchBox={false} />
              </div>
            ),
          },
        ],
      },
    ],
  },
];
